import { Box, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

type PaginationButtonsProps = {
  slidesNumber: number;
  activeIndex: number;
};

export const PaginationDashes: FC<PaginationButtonsProps> = ({
  slidesNumber,
  activeIndex,
}) => {
  if (slidesNumber <= 1) return null;

  return (
    <Flex justify="center" gap={16}>
      {Array.from({ length: slidesNumber }, (_, i) => i).map((_, index) => (
        <Box
          as="span"
          key={index}
          md={{ height: 4, width: 32 }}
          width={32}
          height={4}
          border={{ radius: "9999px" }}
          bg={activeIndex === index ? "border-selected" : "border-secondary"}
        />
      ))}
    </Flex>
  );
};
